import styled from 'styled-components';

export const StyledNavigationLink = styled.a`
  background-color: ${({ theme }): string => theme.colors.mainBackground};
  border-radius: ${({ theme }): string => theme.radii.xl};
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 8px;
`;
